module.exports = __webpack_public_path__ + "img/volodymyr-hryshchenko-x_OKGbxB3fA-unsplash.1e35935d.jpg";